import "core-js/modules/es6.string.starts-with";
var FILE_BASE = process.env.VUE_APP_FILE_URL || '';

/**
 * 半路径存储规则: 库内只存 "/bucket/objectPath"。
 * 全路径(http/https)原样返回, 兼容存量数据。
 */
export function resolveFileUrl(path) {
  if (!path || typeof path !== 'string') return path;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/') && FILE_BASE) return FILE_BASE + path;
  return path;
}